import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  height: var(--header-height);
  padding: 0 24px;
  background: var(--color-white);
`;

export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
`;

export const LogoLink = styled(NavLink)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: -10px;
`;

export const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/* ── AI Button ─────────────────────────────────── */

export const AiWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const AiButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border-radius: var(--border-radius);
  background-color: var(--color-primary);
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--color-white);
  cursor: pointer;
  white-space: nowrap;
  @media (hover) {
    &:hover {
      opacity: 0.9;
    }
  }
`;

export const AiBadge = styled.span`
  display: ${({ $hasNew }) => ($hasNew ? 'flex' : 'none')};
  position: absolute;
  top: -6px;
  right: -6px;
  align-items: center;
  justify-content: center;
  background-color: var(--color-black);
  color: var(--color-white);
  font-family: 'Geist', sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
  padding: 0 5px;
  border-radius: var(--border-radius);
  white-space: nowrap;
`;

/* ── Unauthenticated outline buttons ────────────── */

export const OutlineNavButton = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  border: 1px solid var(--color-grey-e5);
  border-radius: var(--border-radius);
  background-color: transparent;
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--color-black);
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  @media (hover) {
    &:hover {
      border-color: var(--color-primary);
      color: var(--color-primary);
    }
  }
`;
